const ConditionsEnum = {
    TEN_DAY_PAYMENT_DELAY: 'Odgoda 10 dana',
    FIFTEEN_DAY_PAYMENT_DELAY: 'Odgoda 15 dana'
  };

export default ConditionsEnum;